/** The prototype's integer hash (`hash`). Deterministic; used only for stable shuffles. */
export function hash(value: number): number {
  let a = value | 0;
  a = (a ^ 61) ^ (a >>> 16);
  a = (a + (a << 3)) | 0;
  a = a ^ (a >>> 4);
  a = Math.imul(a, 0x27d4eb2d);
  a = a ^ (a >>> 15);
  return a >>> 0;
}

/**
 * Pop-in order of the member tiles of a day (`popRanks`): `rank[i]` is the position of tile `i`
 * in a shuffle seeded by the day, so a day always pops in the same order.
 */
export function popRanks(dayNumber: number, count: number): number[] {
  const order = Array.from({ length: count }, (_, i) => i);
  order.sort((a, b) => hash(dayNumber * 97 + a * 13 + 5) - hash(dayNumber * 97 + b * 13 + 5));
  const rank: number[] = new Array<number>(count).fill(0);
  order.forEach((tile, position) => { rank[tile] = position; });
  return rank;
}
